import { Center, Flex, Text, Spinner } from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";

import { TILL_DATE } from "@constants/constants";

let interval: any;

interface CountDownProps {
  days: undefined | number;
  minutes: undefined | number;
  hours: undefined | number;
}

const getTimeDifference = () => {
  const then = moment.utc(TILL_DATE).local() as any;
  const now = moment(new Date().toUTCString()) as any;

  const days = then.diff(now, "days");
  const hours = then.diff(now, "hours") % 24;
  const minutes = (then.diff(now, "minutes") % (24 * 60)) - hours * 60;
  return {
    days,
    hours,
    minutes,
  };
};

const CountDown = () => {
  const [countdown, setCountDown] = useState<CountDownProps>({
    days: undefined,
    minutes: undefined,
    hours: undefined,
  });

  useEffect(() => {
    const { days, hours, minutes } = getTimeDifference();
    setCountDown({
      days: days,
      hours: hours,
      minutes: minutes,
    });

    interval = setInterval(() => {
      const { days, hours, minutes } = getTimeDifference();

      setCountDown({
        days: days,
        hours: hours,
        minutes: minutes,
      });
    }, 30000);

    return () => {
      interval && clearInterval(interval);
    };
  }, []);

  const getCountDownNumber = useCallback(
    (value: number | undefined, time: string) => {
      return (
        <Flex flexDir="column" gap="2px" alignItems="center">
          <Center
            w="40px"
            gap="8px"
            bg="#F5F5F7"
            color="textPrimary"
            borderRadius="12px"
            h="36px"
            _dark={{
              bg: "#142528",
            }}
          >
            {value || value === 0 ? (
              <Text>{value}</Text>
            ) : (
              <Spinner size="sm" />
            )}
          </Center>
          <Text fontSize="10px" fontWeight="500" lineHeight="150%">
            {time}
          </Text>
        </Flex>
      );
    },
    []
  );

  return (
    <Flex
      gap="8px"
      alignItems="center"
      fontSize="14px"
      fontWeight="600"
      lineHeight="20px"
      _dark={{
        color: "#A1B6BA",
      }}
    >
      {getCountDownNumber(countdown.days, "Days")}
      <Text mb="1rem">:</Text>
      {getCountDownNumber(countdown.hours, "Hours")}
      <Text mb="1rem">:</Text>
      {getCountDownNumber(countdown.minutes, "Mins")}
    </Flex>
  );
};

export default CountDown;
